/**
 * Learn more about theme events at
 * https://help.switchthemes.co/baseline/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('baseline:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.body.addEventListener('cart-will-open', async () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-is-open', async () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'drawer' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'drawer' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

document.addEventListener('click', (event) => {
  if (
    window.theme.settings.cartType !== 'drawer' ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  const target =
    event.target instanceof Element ? event.target : event.target.parentElement;
  const link = target && target.closest('a[href]');
  if (!link || link.target === '_blank') return;

  const cartUrl = window.theme.routes && window.theme.routes.cart_url;
  if (!cartUrl) return;

  const linkPath = new URL(link.href, window.location.origin).pathname;
  const cartPath = new URL(cartUrl, window.location.origin).pathname;
  if (linkPath !== cartPath || window.location.pathname === cartPath) return;

  event.preventDefault();
  document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
});

const checkoutLoadingStyles = `
  .somsoc-checkout-loading {
    background: #d2ff00 !important;
    border-color: #000 !important;
    color: #000 !important;
    overflow: hidden !important;
    position: relative !important;
  }

  .somsoc-checkout-loading > * {
    visibility: hidden !important;
  }

  .somsoc-checkout-loading::before {
    background: #000;
    content: "";
    display: block;
    inset: 0 auto 0 0;
    opacity: 1;
    position: absolute;
    transform: scaleX(var(--somsoc-checkout-progress, 0.03));
    transform-origin: left center;
    transition: transform 80ms linear;
    width: 100%;
    z-index: 1;
  }

  .somsoc-checkout-loading::after {
    color: #d2ff00 !important;
    content: "LOADING " attr(data-somsoc-checkout-progress) "%";
    font-size: 12px;
    font-weight: 900;
    left: 50%;
    letter-spacing: 0;
    line-height: 1;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    z-index: 2;
  }
`;

const checkoutLoadingStyleEl = document.createElement('style');
checkoutLoadingStyleEl.textContent = checkoutLoadingStyles;
document.head.appendChild(checkoutLoadingStyleEl);

const isCheckoutTarget = (element) => {
  if (!element) return false;

  const href = element.getAttribute('href') || '';
  const action = element.closest('form')?.getAttribute('action') || '';
  const name = element.getAttribute('name') || '';
  const text = (element.textContent || '').trim();

  return (
    name === 'checkout' ||
    href.includes('/checkout') ||
    action.includes('/checkout') ||
    text.includes('レジに進む') ||
    text.toLowerCase().includes('checkout')
  );
};

const startCheckoutLoading = (element) => {
  element.classList.add('somsoc-checkout-loading');
  element.setAttribute('aria-busy', 'true');
  element.setAttribute('data-somsoc-checkout-progress', '3');
  element.style.setProperty('--somsoc-checkout-progress', '0.03');

  let progress = 3;
  const timer = window.setInterval(() => {
    const step = progress < 70 ? 9 : progress < 90 ? 5 : 2;
    progress = Math.min(96, progress + step + Math.floor(Math.random() * 4));
    element.setAttribute('data-somsoc-checkout-progress', String(Math.round(progress)));
    element.style.setProperty('--somsoc-checkout-progress', String(progress / 100));
  }, 45);

  window.setTimeout(() => window.clearInterval(timer), 1200);
};

document.addEventListener(
  'click',
  (event) => {
    const target =
      event.target instanceof Element ? event.target : event.target.parentElement;
    const checkoutElement =
      target &&
      target.closest('a[href], button, input[type="submit"], [role="button"]');

    if (!isCheckoutTarget(checkoutElement)) return;
    if (checkoutElement.dataset.somsocCheckoutContinue === 'true') {
      checkoutElement.dataset.somsocCheckoutContinue = 'false';
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    startCheckoutLoading(checkoutElement);

    window.setTimeout(() => {
      checkoutElement.dataset.somsocCheckoutContinue = 'true';

      if (checkoutElement.tagName === 'A' && checkoutElement.href) {
        window.location.href = checkoutElement.href;
        return;
      }

      const form = checkoutElement.closest('form');
      if (form) {
        let checkoutInput = form.querySelector('input[name="checkout"][type="hidden"]');
        if (!checkoutInput) {
          checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          form.appendChild(checkoutInput);
        }
        checkoutInput.value = checkoutElement.value || 'checkout';
        form.submit();
        return;
      }

      checkoutElement.click();
    }, 700);
  },
  true
);

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}
